import { cx } from "@frontend/components/ui";

/**
 * Which side of the collab the viewer is on. The arrow direction mirrors the
 * dashboard's Earning/Spent split — in toward you, or out from you.
 */
export function CollabRoleBadge({
  role,
  className,
}: {
  role: "creator" | "brand";
  className?: string;
}) {
  const delivering = role === "creator";

  return (
    <span
      title={delivering ? "You deliver" : "You booked"}
      aria-label={delivering ? "You deliver" : "You booked"}
      className={cx(
        "inline-flex size-4 shrink-0 items-center justify-center rounded ring-1",
        delivering
          ? "bg-money-50 text-money-700 ring-money-100"
          : "bg-brand-50 text-brand-700 ring-brand-100",
        className,
      )}
    >
      <svg viewBox="0 0 20 20" fill="currentColor" className="size-2.5" aria-hidden="true">
        {delivering ? (
          <path
            fillRule="evenodd"
            d="M14.78 5.22a.75.75 0 0 1 0 1.06L7.06 14h5.19a.75.75 0 0 1 0 1.5H5.25a.75.75 0 0 1-.75-.75V7.75a.75.75 0 0 1 1.5 0v5.19l7.72-7.72a.75.75 0 0 1 1.06 0Z"
            clipRule="evenodd"
          />
        ) : (
          <path
            fillRule="evenodd"
            d="M5.22 14.78a.75.75 0 0 0 1.06 0L14 7.06v5.19a.75.75 0 0 0 1.5 0V5.25a.75.75 0 0 0-.75-.75H7.75a.75.75 0 0 0 0 1.5h5.19l-7.72 7.72a.75.75 0 0 0 0 1.06Z"
            clipRule="evenodd"
          />
        )}
      </svg>
    </span>
  );
}
